import React from 'react';

const Logo = ({ className = "", variant = "full", inverted = false, white = false }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/florentina-logo-real.png"
        alt="Florentina Infra LLP"
        className={`${
          variant === 'icon' 
            ? 'h-12 md:h-14' 
            : 'h-16 md:h-20 lg:h-24'
        } w-auto object-contain`}
        style={{ 
          filter: white ? 'brightness(0) invert(1)' : inverted ? 'brightness(0) invert(1)' : 'none',
        }}
      />
    </div>
  );
};

export default Logo;
